/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { Fragment, useCallback, useEffect } from 'react';
import reCaptchaV3Plugin from '../../utils/third-party-plugins/recaptcha-v3';
const MemershipDetails = props => {
  // eslint-disable-next-line react/prop-types
  const { isMember, membershipDetails, phase3 } = props;

  const recaptchaV3PluginFunction = useCallback(() => {
    try {
      window.grecaptcha.ready(() => {
        reCaptchaV3Plugin('membership_details_page');
      });
    } catch (err) {
      /* eslint-disable-next-line no-console */
      console.log('reCaptchav3 init error - MembershipDetails:', err);
    }
  }, []);

  useEffect(
    () => {
      recaptchaV3PluginFunction();
    },
    [recaptchaV3PluginFunction],
  );

  return (
    <Fragment>
      <div className="select-service__include">
        <div className="hdg-wave select-service__plus">
          <i className="icon icon--squiggle hdg-wave__icon" />
          <span className="hdg-wave__text">plus</span>
        </div>
        <div className="select-service__row select-service__row-b rowp4 hide-phone">
          <div className="select-service__col-b">
            <i className="icon-membership icon-membership--gift" />
            <p>Gift your monthly massage or unused credits to a friend</p>
          </div>
          <div className="select-service__col-b">
            <i className="icon-membership icon-membership--rollover" />
            <p>Unused monthly credits roll over and never expire</p>
          </div>
        </div>
      </div>
      <div className="select-service__help hide-phone">
        <div className="select-service__line">
          <i className="icon icon--squiggle" />
        </div>
        <p>
          For every membership sold, Squeeze is helping to provide a day of
          canine support to a person with a disability through Canine Companions
        </p>
      </div>
      <div className="select-service__help membership-gitft-txt phone-only">
        <div className="membership-section">
          <div className="select-service__col-b">
            <i className="icon-membership icon-membership--gift" />
            <p>
              Gift your monthly<br /> massage or unused <br />credits to a
              friend
            </p>
          </div>
          <div className="select-service__col-b">
            <i className="icon-membership icon-membership--rollover" />
            <p>
              Unused monthly credits <br /> roll over and never expire
            </p>
          </div>
        </div>
        {!phase3 && (
          <div>
            <p>
              No obligation. You're billed month-to-month and can cancel at any
              time.
            </p>
            <p>Exclusive member promotions & events.</p>
          </div>
        )}
        {phase3 && (
          <div className="hdg-wave select-service__plus">
            <i className="icon icon--squiggle hdg-wave__icon" />
          </div>
        )}
        <p>
          For every membership sold, Squeeze is helping to provide a day of
          canine support to a person with a disability through Canine
          Companions.
        </p>
      </div>
      <div className="select-service__dog">
        <i className="icon-membership icon-membership--thank-you-dog" />
      </div>
    </Fragment>
  );
};

export default MemershipDetails;
